// Application constants

// VSNP-704: previously a hardcoded 20-minute TTL was stamped on every
// auth storage entry. Auth lifetime is now driven by `useIdleTimeout`
// (activity-based; `sessionManagement.idleTimeoutMinutes` setting) +
// backend session expiry (8h, proactively refreshed). No constants
// needed here.

// CHANNEL_ADMIN (5) is the Channel middle layer: SuperAdmin > ChannelAdmin > TenantAdmin.
// Like a SuperAdmin it has no tenant of its own (`tenantId: null`) and picks one from
// the topbar; unlike a SuperAdmin its reachable set is a group of tenants, resolved
// server-side on every request. Type 4 is unused.
export const USER_TYPES = {
  SUPER_ADMIN: 1,
  TENANT_ADMIN: 2,
  USER: 3,
  CHANNEL_ADMIN: 5,
} as const;

export const API_ERROR_CODES = {
  SUCCESS: 10000,
  TOKEN_ERROR_1: 10010,
  TOKEN_ERROR_2: 10011,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
} as const;

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_DATA: 'userData',
  MENU_DATA: 'menuData',
  TENANT_VALUE: 'tenantValue',
  LANGUAGE: 'User-Language',
} as const;

export const DEFAULT_PAGE_SIZE = 10;

// Hard ceiling enforced by the API's shared `paginationSchema`
// (vsm-api-v2 src/utils/validation-schemas.ts). Asking for more is a 400, not
// a clamp — so any caller that wants "everything" must page, not over-ask.
export const MAX_PAGE_SIZE = 100;

export const DEVICE_STATUS = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  DISCONNECT: 'Disconnect',
} as const;

// Re-export RBAC constants from permissions utility
export { ROLE_TYPES, ROLE_PERMISSIONS } from './permissions';

